import { render, staticRenderFns } from "./contentAliasNames.vue?vue&type=template&id=0ba50052&scoped=true"
import script from "./contentAliasNames.vue?vue&type=script&lang=js"
export * from "./contentAliasNames.vue?vue&type=script&lang=js"
import style0 from "./contentAliasNames.vue?vue&type=style&index=0&id=0ba50052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba50052",
  null
  
)

export default component.exports